/* eslint-disable indent */
import Pagination from 'react-bootstrap/Pagination'

const Pages = ({ currentPage, totalPages, onPageChange }) => {
  const handlePageChange = page => {
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      onPageChange(page)
    }
  }

  const generatePaginationItems = () => {
    const items = []
    const maxVisiblePages = 5 // Näytetään maksimissaan 5 sivua kerralla
    const halfVisible = Math.floor(maxVisiblePages / 2)

    let startPage = Math.max(1, currentPage - halfVisible)
    let endPage = Math.min(totalPages, currentPage + halfVisible)

    // Siirrä alue, jos se ei kata riittävästi sivuja
    if (currentPage - halfVisible < 1) {
      endPage = Math.min(totalPages, endPage + (1 - startPage))
    } else if (currentPage + halfVisible > totalPages) {
      startPage = Math.max(
        1,
        startPage - (currentPage + halfVisible - totalPages)
      )
    }

    if (startPage > 1) {
      items.push(
        <Pagination.Ellipsis
          key="start-ellipsis"
          onClick={() => handlePageChange(1)}
        />
      )
    }

    for (let page = startPage; page <= endPage; page++) {
      items.push(
        <Pagination.Item
          key={page}
          active={page === currentPage}
          onClick={() => handlePageChange(page)}
          style={
            page === currentPage
              ? {
                  backgroundColor: '#343a40',
                  borderColor: '#343a40',
                  color: 'white',
                }
              : null
          }
        >
          {page}
        </Pagination.Item>
      )
    }

    if (endPage < totalPages) {
      items.push(
        <Pagination.Ellipsis
          key="end-ellipsis"
          onClick={() => handlePageChange(totalPages)}
        />
      )
    }

    return items
  }

  return (
    <Pagination size="sm" className="justify-content-center">
      <Pagination.First onClick={() => handlePageChange(1)} />
      <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} />
      {generatePaginationItems()}
      <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} />
      <Pagination.Last onClick={() => handlePageChange(totalPages)} />
    </Pagination>
  )
}

export default Pages
